import Store from "../";
import Mutations from "../mutations";
import { Promise } from "es6-promise";
import common from "../api/ajax";
import utils from '@/lib/utils';

const packageModule = {
  namespaced: true,
  state: {
    packageTemplates: [],
    packageTemplateDetails: {}
  },
  getters: { 
    PACKAGE_TEMPLATE_LIST: state => {
      return state.packageTemplates;
    },
    PACKAGE_TEMPLATE_DATA: state => {
      return state.packageTemplateDetails;
    }
  },
  mutations: { 
    GET_PACKAGE_TEMPLATE_LIST: (state, payload) => {
      let packageTemplates = payload.results;
      Store.state.pagination.total = payload.count;
      Store.state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      Store.state.pageArrow.prev = payload.previous;
      Store.state.pageArrow.next = payload.next;
      state.packageTemplates = packageTemplates;
      Mutations.setPaginator(Store.state, Store.state.pagination);
    },
    GET_PACKAGE_TEMPLATE_DETAIL: (state, payload) => {
      state.packageTemplateDetails = payload;
    }
  },
  actions: { 
    GET_PACKAGE_OPTIONS: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.getRequest(
          `/api/v1/${utils.getProjectId()}/packagetemplate/get_package_options/`,
          payload.data,
          function(res) {
            resolve(res);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    GET_PACKAGE_TEMPLATE_LIST: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.getRequest(
          `/api/v1/${utils.getProjectId()}/packagetemplate/`,
          payload,
          function(res) {
            if (payload != null) {
              res.data["page"] = payload.params.page;
            }
            context.commit("GET_PACKAGE_TEMPLATE_LIST", res.data);
            resolve(res);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    GET_PACKAGE_TEMPLATE_DETAIL: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.getRequest(
          `/api/v1/${utils.getProjectId()}/packagetemplate/${payload.id}/`,
          {},
          function(res) {
            context.commit("GET_PACKAGE_TEMPLATE_DETAIL", res.data);
            resolve(res);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    ADD_PACKAGE_TEMPLATE: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.postRequest(
          `/api/v1/${utils.getProjectId()}/packagetemplate/`,
          payload.data,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    UPDATE_PACKAGE_TEMPLATE: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.putRequest(
          `/api/v1/${utils.getProjectId()}/packagetemplate/${payload.id}/`,
          payload.data,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    DELETE_PACKAGE_TEMPLATE: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.deleteRequest(
          `/api/v1/${utils.getProjectId()}/packagetemplate/${payload.id}/`,
          {},
          function(res) {
            resolve(res);
          },
          function(error) {
            reject(error);
          }
        );
      });
    }
  }
}
export default packageModule;


// WEBPACK FOOTER //
// ./src/store/modules/package.js